import { QualityRecordRequest, QualityRecordResponse } from 'api/Responses/QualityRecordResponseRequest';
import axiosInstance from 'services/APIService';

const ENDPOINT_PATH = `/v1/reports/quality_record`;

/*
 * Lists all orders in receiving
 */
export const getQualityRecord = async (QualityRecordRequest: QualityRecordRequest): Promise<QualityRecordResponse> => {
  const response = await axiosInstance.get<QualityRecordResponse>(
    `${ENDPOINT_PATH}/${QualityRecordRequest.delivery_code}/${QualityRecordRequest.set_code}/`,
  );
  return response.data;
};
